// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
	env      : 'development',
	firebase : {
		apiKey            : 'AIzaSyAhT11HOJJRLy_Jfgnzle3xZVA6j2NksVo',
		authDomain        : 'shop-holla-draft.firebaseapp.com',
		databaseURL       : 'https://shop-holla-draft.firebaseio.com',
		projectId         : 'shop-holla-draft',
		storageBucket     : 'shop-holla-draft.appspot.com',
		messagingSenderId : '1046174483891'
  }
};


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-dev/src/environments/environment.ts